/* eslint-disable @typescript-eslint/no-explicit-any */

const countryList = [
    { id: 0, text: 'United States', value: 'US' },
    { id: 1, text: 'United Kingdom', value: 'GB' },
    { id: 999, text: '', disabled: true, value: '' },
    { id: 2, text: 'Afghanistan', value: 'AF' },
    { id: 3, text: 'Åland Islands', value: 'AX' },
    { id: 4, text: 'Albania', value: 'AL' },
    { id: 5, text: 'Algeria', value: 'DZ' },
    { id: 6, text: 'American Samoa', value: 'AS' },
    { id: 7, text: 'Andorra', value: 'AD' },
    { id: 8, text: 'Angola', value: 'AI' },
    { id: 9, text: 'Anguilla', value: 'AO' },
    { id: 10, text: 'Antarctica', value: 'AQ' },
    { id: 11, text: 'Antigua & Barbuda', value: 'AG' },
    { id: 12, text: 'Argentina', value: 'AR' },
    { id: 13, text: 'Armenia', value: 'AM' },
    { id: 14, text: 'Aruba', value: 'AW' },
    { id: 15, text: 'Australia', value: 'AU' },
    { id: 16, text: 'Austria', value: 'AT' },
    { id: 17, text: 'Azerbaijan', value: 'AZ' },
    { id: 18, text: 'Bahamas', value: 'BS' },
    { id: 19, text: 'Bahrain', value: 'BH' },
    { id: 20, text: 'Bangladesh', value: 'BD' },
    { id: 21, text: 'Barbados', value: 'BB' },
    { id: 22, text: 'Belarus', value: 'BY' },
    { id: 23, text: 'Belgium', value: 'BE' },
    { id: 24, text: 'Belize', value: 'BZ' },
    { id: 25, text: 'Benin', value: 'BJ' },
    { id: 26, text: 'Bermuda', value: 'BM' },
    { id: 27, text: 'Bhutan', value: 'BT' },
    { id: 28, text: 'Bolivia', value: 'BO' },
    { id: 29, text: 'Bosnia-Herzegovina', value: 'BA' },
    { id: 30, text: 'Botswana', value: 'BW' },
    { id: 31, text: 'Bouvet Island', value: 'BV' },
    { id: 32, text: 'Brazil', value: 'BR' },
    { id: 33, text: 'British Indian Ocean Territory', value: 'IO' },
    { id: 34, text: 'British Virgin Islands', value: 'VG' },
    { id: 35, text: 'Brunei Darussalam', value: 'BN' },
    { id: 36, text: 'Bulgaria', value: 'BG' },
    { id: 37, text: 'Burkina Faso', value: 'BF' },
    { id: 38, text: 'Burundi', value: 'BI' },
    { id: 39, text: 'Cambodia', value: 'KH' },
    { id: 40, text: 'Cameroon', value: 'CM' },
    { id: 41, text: 'Canada', value: 'CA' },
    { id: 42, text: 'Cape Verde', value: 'CV' },
    { id: 43, text: 'Cayman Islands', value: 'KY' },
    { id: 44, text: 'Central African Republic', value: 'CF' },
    { id: 45, text: 'Chad', value: 'TD' },
    { id: 46, text: 'Chile', value: 'CL' },
    { id: 47, text: 'China', value: 'CN' },
    { id: 48, text: 'Christmas Island', value: 'CX' },
    { id: 49, text: 'Cocos Islands', value: 'CC' },
    { id: 50, text: 'Colombia', value: 'CO' },
    { id: 51, text: 'Comoros', value: 'KM' },
    { id: 52, text: 'Congo', value: 'CG' },
    { id: 53, text: 'Cook Islands', value: 'CK' },
    { id: 54, text: 'Costa Rica', value: 'CR' },
    { id: 55, text: "Côte d'Ivoire", value: 'CI' },
    { id: 56, text: 'Croatia', value: 'HR' },
    { id: 57, text: 'Cuba', value: 'CU' },
    { id: 58, text: 'Curaçao', value: 'CW' },
    { id: 59, text: 'Cyprus', value: 'CY' },
    { id: 60, text: 'Czech Republic', value: 'CZ' },
    { id: 61, text: 'Denmark', value: 'DK' },
    { id: 62, text: 'Djibouti', value: 'DJ' },
    { id: 63, text: 'Dominica', value: 'DM' },
    { id: 64, text: 'Dominican Republic', value: 'DO' },
    { id: 65, text: 'Ecuador', value: 'EC' },
    { id: 66, text: 'Egypt', value: 'EG' },
    { id: 67, text: 'El Salvador', value: 'SV' },
    { id: 68, text: 'Equatorial Guinea', value: 'GQ' },
    { id: 69, text: 'Eritrea', value: 'ER' },
    { id: 70, text: 'Estonia', value: 'EE' },
    { id: 71, text: 'Ethiopia', value: 'ET' },
    { id: 72, text: 'Falkland Islands', value: 'FK' },
    { id: 73, text: 'Faroe Islands', value: 'FO' },
    { id: 74, text: 'Fiji', value: 'FJ' },
    { id: 75, text: 'Finland', value: 'FI' },
    { id: 76, text: 'France', value: 'FR' },
    { id: 77, text: 'French Guiana', value: 'GF' },
    { id: 78, text: 'French Polynesia', value: 'PF' },
    { id: 79, text: 'French Southern Territories', value: 'TF' },
    { id: 80, text: 'Gabon', value: 'GA' },
    { id: 81, text: 'Gambia', value: 'GM' },
    { id: 82, text: 'Georgia', value: 'GE' },
    { id: 83, text: 'Germany', value: 'DE' },
    { id: 84, text: 'Ghana', value: 'GH' },
    { id: 85, text: 'Gibraltar', value: 'GI' },
    { id: 86, text: 'Greece', value: 'GR' },
    { id: 87, text: 'Greenland', value: 'GL' },
    { id: 88, text: 'Grenada', value: 'GD' },
    { id: 89, text: 'Guadeloupe', value: 'GP' },
    { id: 90, text: 'Guam', value: 'GU' },
    { id: 91, text: 'Guatemala', value: 'GT' },
    { id: 92, text: 'Guernsey', value: 'GG' },
    { id: 93, text: 'Guinea', value: 'GN' },
    { id: 94, text: 'Guinea-Bissau', value: 'GW' },
    { id: 95, text: 'Guyana', value: 'GY' },
    { id: 96, text: 'Haiti', value: 'HT' },
    { id: 97, text: 'Heard Island and McDonald Islands', value: 'HM' },
    { id: 98, text: 'Honduras', value: 'HN' },
    { id: 99, text: 'Hong Kong', value: 'HK' },
    { id: 100, text: 'Hungary', value: 'HU' },
    { id: 101, text: 'Iceland', value: 'IS' },
    { id: 102, text: 'India', value: 'IN' },
    { id: 103, text: 'Indonesia', value: 'ID' },
    { id: 104, text: 'Iran', value: 'IR' },
    { id: 105, text: 'Iraq', value: 'IQ' },
    { id: 106, text: 'Ireland', value: 'IE' },
    { id: 107, text: 'Isle of Man', value: 'IM' },
    { id: 108, text: 'Israel', value: 'IL' },
    { id: 109, text: 'Italy', value: 'IT' },
    { id: 110, text: 'Jamaica', value: 'JM' },
    { id: 111, text: 'Japan', value: 'JP' },
    { id: 112, text: 'Jersey', value: 'JE' },
    { id: 113, text: 'Jordan', value: 'JO' },
    { id: 114, text: 'Kazakhstan', value: 'KZ' },
    { id: 115, text: 'Kenya', value: 'KE' },
    { id: 116, text: 'Kiribati', value: 'KI' },
    { id: 117, text: 'Kuwait', value: 'KW' },
    { id: 118, text: 'Kyrgyzstan', value: 'KG' },
    { id: 119, text: 'Laos', value: 'LA' },
    { id: 120, text: 'Latvia', value: 'LV' },
    { id: 121, text: 'Lebanon', value: 'LB' },
    { id: 122, text: 'Lesotho', value: 'LS' },
    { id: 123, text: 'Liberia', value: 'LR' },
    { id: 124, text: 'Libya', value: 'LY' },
    { id: 125, text: 'Liechtenstein', value: 'LI' },
    { id: 126, text: 'Lithuania', value: 'LT' },
    { id: 127, text: 'Luxembourg', value: 'LU' },
    { id: 128, text: 'Macau', value: 'MO' },
    { id: 129, text: 'Macedonia', value: 'MK' },
    { id: 130, text: 'Madagascar', value: 'MG' },
    { id: 131, text: 'Malawi', value: 'MW' },
    { id: 132, text: 'Malaysia', value: 'MY' },
    { id: 133, text: 'Maldives', value: 'MV' },
    { id: 134, text: 'Mali', value: 'ML' },
    { id: 135, text: 'Malta', value: 'MT' },
    { id: 136, text: 'Marshall Islands', value: 'MH' },
    { id: 137, text: 'Martinique', value: 'MQ' },
    { id: 138, text: 'Mauritania', value: 'MR' },
    { id: 139, text: 'Mauritius', value: 'MU' },
    { id: 140, text: 'Mayotte', value: 'YT' },
    { id: 141, text: 'Mexico', value: 'MX' },
    { id: 142, text: 'Micronesia, Federated States of', value: 'FM' },
    { id: 143, text: 'Moldova', value: 'MD' },
    { id: 144, text: 'Monaco', value: 'MC' },
    { id: 145, text: 'Mongolia', value: 'MN' },
    { id: 146, text: 'Montenegro', value: 'ME' },
    { id: 147, text: 'Montserrat', value: 'MS' },
    { id: 148, text: 'Morocco', value: 'MA' },
    { id: 149, text: 'Mozambique', value: 'MZ' },
    { id: 150, text: 'Myanmar', value: 'MM' },
    { id: 151, text: 'Namibia', value: 'NA' },
    { id: 152, text: 'Nauru', value: 'NR' },
    { id: 153, text: 'Nepal', value: 'NP' },
    { id: 154, text: 'Netherlands', value: 'NL' },
    { id: 155, text: 'Netherlands Antilles', value: 'BQ' },
    { id: 156, text: 'New Caledonia', value: 'NC' },
    { id: 157, text: 'New Zealand', value: 'NZ' },
    { id: 158, text: 'Nicaragua', value: 'NI' },
    { id: 159, text: 'Niger', value: 'NE' },
    { id: 160, text: 'Nigeria', value: 'NG' },
    { id: 161, text: 'Niue', value: 'NU' },
    { id: 162, text: 'Norfolk Island', value: 'NF' },
    { id: 163, text: 'North Korea', value: 'KP' },
    { id: 164, text: 'Northern Mariana Islands', value: 'MP' },
    { id: 165, text: 'Norway', value: 'NO' },
    { id: 166, text: 'Oman', value: 'OM' },
    { id: 167, text: 'Pakistan', value: 'PK' },
    { id: 168, text: 'Palau', value: 'PW' },
    { id: 169, text: 'Palestinian Authority', value: 'PS' },
    { id: 170, text: 'Panama', value: 'PA' },
    { id: 171, text: 'Papua New Guinea', value: 'PG' },
    { id: 172, text: 'Paraguay', value: 'PY' },
    { id: 173, text: 'Peru', value: 'PE' },
    { id: 174, text: 'Philippines', value: 'PH' },
    { id: 175, text: 'Pitcairn', value: 'PN' },
    { id: 176, text: 'Poland', value: 'PL' },
    { id: 177, text: 'Portugal', value: 'PT' },
    { id: 178, text: 'Puerto Rico', value: 'PR' },
    { id: 179, text: 'Qatar', value: 'QA' },
    { id: 180, text: 'Republic of the Congo', value: 'CG' },
    { id: 181, text: 'Reunion', value: 'RE' },
    { id: 182, text: 'Romania', value: 'RO' },
    { id: 183, text: 'Russia', value: 'RU' },
    { id: 184, text: 'Rwanda', value: 'RW' },
    { id: 185, text: 'Saint Barthélemy', value: 'BL' },
    { id: 186, text: 'Saint Helena', value: 'SH' },
    { id: 187, text: 'Saint Kitts & Nevis', value: 'KN' },
    { id: 188, text: 'Saint Lucia', value: 'LC' },
    { id: 189, text: 'Saint Martin', value: 'MF' },
    { id: 190, text: 'Saint Pierre and Miquelon', value: 'PM' },
    { id: 191, text: 'Saint Vincent & Grenadines', value: 'VC' },
    { id: 192, text: 'Samoa', value: 'WS' },
    { id: 193, text: 'San Marino', value: 'SM' },
    { id: 194, text: 'Sao Tome and Principe', value: 'ST' },
    { id: 195, text: 'Saudi Arabia', value: 'SA' },
    { id: 196, text: 'Senegal', value: 'SN' },
    { id: 197, text: 'Serbia', value: 'RS' },
    { id: 198, text: 'Seychelles', value: 'SC' },
    { id: 199, text: 'Sierra Leone', value: 'SL' },
    { id: 200, text: 'Singapore', value: 'SG' },
    { id: 201, text: 'Slovakia', value: 'SK' },
    { id: 202, text: 'Slovenia', value: 'SI' },
    { id: 203, text: 'Solomon Islands', value: 'SB' },
    { id: 204, text: 'Somalia', value: 'SO' },
    { id: 205, text: 'South Africa', value: 'ZA' },
    { id: 206, text: 'South Georgia and the South Sandwich Islands', value: 'GS' },
    { id: 207, text: 'South Korea', value: 'KR' },
    { id: 208, text: 'Spain', value: 'ES' },
    { id: 209, text: 'Sri Lanka', value: 'LK' },
    { id: 210, text: 'Sudan', value: 'SD' },
    { id: 211, text: 'Suriname', value: 'SR' },
    { id: 212, text: 'Svalbard and Jan Mayen', value: 'SJ' },
    { id: 213, text: 'Swaziland', value: 'SZ' },
    { id: 214, text: 'Sweden', value: 'SE' },
    { id: 215, text: 'Switzerland', value: 'CH' },
    { id: 216, text: 'Syria', value: 'SY' },
    { id: 217, text: 'Taiwan', value: 'TW' },
    { id: 218, text: 'Tajikistan', value: 'TJ' },
    { id: 219, text: 'Tanzania', value: 'TZ' },
    { id: 220, text: 'Thailand', value: 'TH' },
    { id: 221, text: 'Timor-Leste', value: 'TL' },
    { id: 222, text: 'Togo', value: 'TG' },
    { id: 223, text: 'Tonga', value: 'TO' },
    { id: 224, text: 'Trinidad & Tobago', value: 'TT' },
    { id: 225, text: 'Tunisia', value: 'TN' },
    { id: 226, text: 'Turkey', value: 'TR' },
    { id: 227, text: 'Turkmenistan', value: 'TM' },
    { id: 228, text: 'Turks & Caicos Islands', value: 'TC' },
    { id: 229, text: 'Tuvalu', value: 'TV' },
    { id: 230, text: 'Uganda', value: 'UG' },
    { id: 231, text: 'Ukraine', value: 'UA' },
    { id: 232, text: 'United Arab Emirates', value: 'AE' },
    { id: 233, text: 'United States Minor Outlying Islands', value: 'UM' },
    { id: 234, text: 'Uruguay', value: 'UY' },
    { id: 235, text: 'Uzbekistan', value: 'UZ' },
    { id: 236, text: 'Vanuatu', value: 'VU' },
    { id: 237, text: 'Vatican City', value: 'VA' },
    { id: 238, text: 'Venezuela', value: 'VE' },
    { id: 239, text: 'Vietnam', value: 'VN' },
    { id: 240, text: 'Virgin Islands, U.S.', value: 'VI' },
    { id: 241, text: 'Wallis and Futuna', value: 'WF' },
    { id: 242, text: 'Western Sahara', value: 'EH' },
    { id: 243, text: 'Yemen', value: 'YE' },
    { id: 244, text: 'Zambia', value: 'ZM' },
    { id: 245, text: 'Zimbabwe', value: 'ZW' }
];

const optInList = [
    'Åland Islands',
    'Albania',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antarctica',
    'Antigua & Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bosnia-Herzegovina',
    'Botswana',
    'Bouvet Island',
    'Brazil',
    'British Indian Ocean Territory',
    'British Virgin Islands',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Cape Verde',
    'Cayman Islands',
    'Central African Republic',
    'Chad',
    'Chile',
    'China',
    'Christmas Island',
    'Cocos Islands',
    'Colombia',
    'Comoros',
    'Congo',
    'Cook Islands',
    'Costa Rica',
    "Côte d'Ivoire",
    'Croatia',
    'Curaçao',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'El Salvador',
    'Eritrea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands',
    'Faroe Islands',
    'Fiji',
    'Finland',
    'France',
    'French Guiana',
    'French Polynesia',
    'French Southern Territories',
    'Gambia',
    'Georgia',
    'Germany',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Grenada',
    'Guadeloupe',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Heard Island and McDonald Islands',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iraq',
    'Ireland',
    'Isle of Man',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jersey',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macau',
    'Macedonia',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Martinique',
    'Mauritania',
    'Mauritius',
    'Mayotte',
    'Mexico',
    'Micronesia, Federated States of',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Morocco',
    'Mozambique',
    'Myanmar',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'Netherlands Antilles',
    'New Caledonia',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Niue',
    'Norfolk Island',
    'Northern Mariana Islands',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestinian Authority',
    'Panama',
    'Paraguay',
    'Peru',
    'Philippines',
    'Pitcairn',
    'Poland',
    'Portugal',
    'Qatar',
    'Republic of the Congo',
    'Reunion',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Barthélemy',
    'Saint Helena',
    'Saint Kitts & Nevis',
    'Saint Lucia',
    'Saint Martin',
    'Saint Pierre and Miquelon',
    'Saint Vincent & Grenadines',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Georgia and the South Sandwich Islands',
    'South Korea',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Svalbard and Jan Mayen',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Tajikistan',
    'Tanzania',
    'Timor-Leste',
    'Togo',
    'Tonga',
    'Trinidad & Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks & Caicos Islands',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Vatican City',
    'Venezuela',
    'Vietnam',
    'Wallis and Futuna',
    'Western Sahara',
    'Zambia',
    'Zimbabwe'
];

const usStates = [
    { id: 'AK', text: 'AK' },
    { id: 'AL', text: 'AL' },
    { id: 'AR', text: 'AR' },
    { id: 'AZ', text: 'AZ' },
    { id: 'CA', text: 'CA' },
    { id: 'CO', text: 'CO' },
    { id: 'CT', text: 'CT' },
    { id: 'DC', text: 'DC' },
    { id: 'DE', text: 'DE' },
    { id: 'FL', text: 'FL' },
    { id: 'GA', text: 'GA' },
    { id: 'GU', text: 'GU' },
    { id: 'HI', text: 'HI' },
    { id: 'IA', text: 'IA' },
    { id: 'ID', text: 'ID' },
    { id: 'IL', text: 'IL' },
    { id: 'IN', text: 'IN' },
    { id: 'KS', text: 'KS' },
    { id: 'KY', text: 'KY' },
    { id: 'LA', text: 'LA' },
    { id: 'MA', text: 'MA' },
    { id: 'MD', text: 'MD' },
    { id: 'ME', text: 'ME' },
    { id: 'MI', text: 'MI' },
    { id: 'MN', text: 'MN' },
    { id: 'MO', text: 'MO' },
    { id: 'MS', text: 'MS' },
    { id: 'MT', text: 'MT' },
    { id: 'NC', text: 'NC' },
    { id: 'ND', text: 'ND' },
    { id: 'NE', text: 'NE' },
    { id: 'NH', text: 'NH' },
    { id: 'NJ', text: 'NJ' },
    { id: 'NM', text: 'NM' },
    { id: 'NV', text: 'NV' },
    { id: 'NY', text: 'NY' },
    { id: 'OH', text: 'OH' },
    { id: 'OK', text: 'OK' },
    { id: 'OR', text: 'OR' },
    { id: 'PA', text: 'PA' },
    { id: 'PR', text: 'PR' },
    { id: 'PW', text: 'PW' },
    { id: 'RI', text: 'RI' },
    { id: 'SC', text: 'SC' },
    { id: 'SD', text: 'SD' },
    { id: 'TN', text: 'TN' },
    { id: 'TX', text: 'TX' },
    { id: 'UT', text: 'UT' },
    { id: 'VA', text: 'VA' },
    { id: 'VT', text: 'VT' },
    { id: 'WA', text: 'WA' },
    { id: 'WI', text: 'WI' },
    { id: 'WV', text: 'WV' },
    { id: 'WY', text: 'WY' }
];

const ausProv = [
    { id: 'ACT', text: 'ACT' },
    { id: 'NSW', text: 'NSW' },
    { id: 'NT', text: 'NT' },
    { id: 'QLD', text: 'QLD' },
    { id: 'SA', text: 'SA' },
    { id: 'TAS', text: 'TAS' },
    { id: 'VIC', text: 'VIC' },
    { id: 'WA', text: 'WA' }
];

const canProv = [
    { id: 'AB', text: 'AB' },
    { id: 'BC', text: 'BC' },
    { id: 'MB', text: 'MB' },
    { id: 'NB', text: 'NB' },
    { id: 'NL', text: 'NL' },
    { id: 'NS', text: 'NS' },
    { id: 'NU', text: 'NU' },
    { id: 'ON', text: 'ON' },
    { id: 'PE', text: 'PE' },
    { id: 'QC', text: 'QC' },
    { id: 'SK', text: 'SK' },
    { id: 'VI', text: 'VI' },
    { id: 'YT', text: 'YT' }
];

const chinaProv = [
    { id: 'Anhui', text: 'Anhui' },
    { id: 'Beijing', text: 'Beijing' },
    { id: 'Chongqing', text: 'Chongqing' },
    { id: 'Fujian', text: 'Fujian' },
    { id: 'Gansu', text: 'Gansu' },
    { id: 'Guangdong', text: 'Guangdong' },
    { id: 'Guangxi', text: 'Guangxi' },
    { id: 'Guizhou', text: 'Guizhou' },
    { id: 'Hainan', text: 'Hainan' },
    { id: 'Hebei', text: 'Hebei' },
    { id: 'Heilongjiang', text: 'Heilongjiang' },
    { id: 'Henan', text: 'Henan' },
    { id: 'Hubei', text: 'Hubei' },
    { id: 'Hunan', text: 'Hunan' },
    { id: 'Inner Mongolia', text: 'Inner Mongolia' },
    { id: 'Jiangsu', text: 'Jiangsu' },
    { id: 'Jiangxi', text: 'Jiangxi' },
    { id: 'Jilin', text: 'Jilin' },
    { id: 'Liaoning', text: 'Liaoning' },
    { id: 'Ningxia', text: 'Ningxia' },
    { id: 'Qinghai', text: 'Qinghai' },
    { id: 'Shaanxi', text: 'Shaanxi' },
    { id: 'Shandong', text: 'Shandong' },
    { id: 'Shanghai', text: 'Shanghai' },
    { id: 'Shanxi', text: 'Shanxi' },
    { id: 'Sichuan', text: 'Sichuan' },
    { id: 'Tianjin', text: 'Tianjin' },
    { id: 'Tibet', text: 'Tibet' },
    { id: 'Xinjiang', text: 'Xinjiang' },
    { id: 'Yunnan', text: 'Yunnan' },
    { id: 'Zhejiang', text: 'Zhejiang' }
];

const companyTypeList = [
    { id: 0, text: 'Academia' },
    { id: 1, text: 'Asset Manager' },
    { id: 2, text: 'Asset Owner' },
    { id: 3, text: 'Auditors/Accounting' },
    { id: 4, text: 'Automobiles and Components' },
    { id: 5, text: 'Capital Goods' },
    { id: 6, text: 'Commercial Bank' },
    { id: 7, text: 'Commercial Services and Supplies' },
    { id: 8, text: 'Consumer Durables and Apparel' },
    { id: 9, text: 'Consumer Services' },
    { id: 10, text: 'Credit Union' },
    { id: 11, text: 'Food and Staples Retailing' },
    { id: 12, text: 'Food, Beverage and Tobacco' },
    { id: 13, text: 'Government Entity/Regulatory Agency' },
    { id: 14, text: 'Healthcare Equipment and Services' },
    { id: 15, text: 'Hedge Fund' },
    { id: 16, text: 'Household and Personal Products' },
    { id: 17, text: 'Individual' },
    { id: 18, text: 'Information Provider' },
    { id: 19, text: 'Insurance' },
    { id: 20, text: 'Investment Bank' },
    { id: 21, text: 'Law Firm' },
    { id: 22, text: 'Materials' },
    { id: 23, text: 'Media/Telecom' },
    { id: 24, text: 'Metals/Mining' },
    { id: 25, text: 'Oil and Gas' },
    { id: 27, text: 'Pharmaceuticals, Biotechnology and Life Sciences' },
    { id: 28, text: 'Power' },
    { id: 29, text: 'Private Equity' },
    { id: 30, text: 'Public Relations/Investor Relations Firm' },
    { id: 31, text: 'Real Estate' },
    { id: 33, text: 'Recruiter/Headhunter' },
    { id: 34, text: 'Retailing' },
    { id: 35, text: 'Strategy/Business Consulting' },
    { id: 36, text: 'Technology' },
    { id: 37, text: 'Trade Association' },
    { id: 38, text: 'Trading Companies and Distributors' },
    { id: 39, text: 'Transportation' },
    { id: 40, text: 'Other' }
];


const InvestmentBank = [
    { id: '200', text: 'Capital Markets (IBD)' },
    { id: '201', text: 'Compliance' },
    { id: '202', text: 'Credit Analyst' },
    { id: '203', text: 'Credit Manager/Officer' },
    { id: '204', text: 'Equity Analyst' },
    { id: '205', text: 'Fixed Income Analyst' },
    { id: '206', text: 'Industry/Sector Coverage (IBD)' },
    { id: '207', text: 'M&A' },
    { id: '208', text: 'Market Data/Business Information' },
    { id: '209', text: 'Prime Services' },
    { id: '2010', text: 'Research ' },
    { id: '2011', text: 'Risk Manager/Officer' },
    { id: '2012', text: 'Sales & Trading' },
    { id: '2013', text: 'Technology' },
    { id: '2014', text: 'Treasury' },
    { id: '2015', text: 'Other' }
];

const PrivateEquity = [
    { id: '290', text: 'Analyst/Associate' },
    { id: '291', text: 'Partner/Principal' },
    { id: '292', text: 'Business Development/Relationship Management' },
    { id: '293', text: 'Market Data' },
    { id: '294', text: 'Other' }
];

const CommercialBank = [
    { id: '60', text: 'Audit/Accounting' },
    { id: '61', text: 'Business Development/Relationship Management' },
    { id: '62', text: 'Credit Analyst' },
    { id: '63', text: 'Credit Manager/Officer' },
    { id: '64', text: 'Credit Risk Modeler' },
    { id: '65', text: 'Economist' },
    { id: '66', text: 'Finance Manager/Officer' },
    { id: '67', text: 'Loan Originator' },
    { id: '68', text: 'Portfolio Manager' },
    { id: '69', text: 'Regulatory Affairs' },
    { id: '610', text: 'Risk Manager/Officer' },
    { id: '611', text: 'Sales/Marketing/PR' },
    { id: '612', text: 'Treasury' },
    { id: '613', text: 'Other' }
];

const CreditUnion = [
    { id: '100', text: 'Business Development/Relationship Management' },
    { id: '101', text: 'Credit Analyst' },
    { id: '102', text: 'Credit Manager/Officer' },
    { id: '103', text: 'Loan Originator' },
    { id: '104', text: 'Regulatory Affairs' },
    { id: '105', text: 'Risk Manager/Officer' },
    { id: '106', text: 'Sales/Marketing/PR' },
    { id: '107', text: 'Other' }
];

const Insurance = [
    { id: '190', text: 'Actuary' },
    { id: '191', text: 'Broker' },
    { id: '192', text: 'Business Development/Relationship Management' },
    { id: '193', text: 'Corporate Finance' },
    { id: '194', text: 'Credit Analyst' },
    { id: '195', text: 'D&O Underwriter' },
    { id: '196', text: 'Insurance Underwriter' },
    { id: '197', text: 'Political Risk Underwriter' },
    { id: '198', text: 'Regulatory Affairs' },
    { id: '199', text: 'Reinsurance Broker/Intermediary' },
    { id: '1910', text: 'Risk Manager/Officer' },
    { id: '1911', text: 'Surety Underwriter' },
    { id: '1912', text: 'Trade Credit/Risk Underwriter' },
    { id: '1913', text: 'Treasury' },
    { id: '1914', text: 'Other' }
];

const AssetManager = [
    { id: '11', text: 'Asset Services' },
    { id: '12', text: 'Credit Analyst' },
    { id: '13', text: 'Credit Manager/Officer' },
    { id: '14', text: 'Economist' },
    { id: '15', text: 'Equity Analyst' },
    { id: '16', text: 'Finance Manager/Officer' },
    { id: '17', text: 'Financial Advisor/Planner' },
    { id: '18', text: 'Fixed Income Analyst' },
    { id: '19', text: 'Investment Strategist' },
    { id: '110', text: 'Investor Relations' },
    { id: '111', text: 'Market Data' },
    { id: '112', text: 'Portfolio Manager' },
    { id: '113', text: 'Private Banker' },
    { id: '114', text: 'Quant' },
    { id: '115', text: 'Quantitative Analyst' },
    { id: '116', text: 'Regulatory Affairs' },
    { id: '117', text: 'Risk Manager/Officer' },
    { id: '118', text: 'Technology' },
    { id: '119', text: 'Treasury' },
    { id: '120', text: 'Other' }
];

const AssetOwner = [
    { id: '21', text: 'Asset Services' },
    { id: '22', text: 'Credit Analyst' },
    { id: '23', text: 'Credit Manager/Officer' },
    { id: '24', text: 'Economist' },
    { id: '25', text: 'Equity Analyst' },
    { id: '26', text: 'Finance Manager/Officer' },
    { id: '27', text: 'Financial Advisor/Planner' },
    { id: '28', text: 'Fixed Income Analyst' },
    { id: '29', text: 'Investment Strategist' },
    { id: '210', text: 'Investor Relations' },
    { id: '211', text: 'Market Data' },
    { id: '212', text: 'Portfolio Manager' },
    { id: '213', text: 'Private Banker' },
    { id: '214', text: 'Quant' },
    { id: '215', text: 'Quantitative Analyst' },
    { id: '216', text: 'Regulatory Affairs' },
    { id: '217', text: 'Risk Manager/Officer' },
    { id: '218', text: 'Technology' },
    { id: '219', text: 'Treasury' },
    { id: '220', text: 'Other' }
];

const HedgeFund = [
    { id: '151', text: 'Asset Services' },
    { id: '152', text: 'Credit Analyst' },
    { id: '153', text: 'Credit Manager/Officer' },
    { id: '154', text: 'Economist' },
    { id: '155', text: 'Equity Analyst' },
    { id: '156', text: 'Finance Manager/Officer' },
    { id: '157', text: 'Financial Advisor/Planner' },
    { id: '158', text: 'Fixed Income Analyst' },
    { id: '159', text: 'Investment Strategist' },
    { id: '1510', text: 'Investor Relations' },
    { id: '1511', text: 'Market Data' },
    { id: '1512', text: 'Portfolio Manager' },
    { id: '1513', text: 'Private Banker' },
    { id: '1514', text: 'Quant' },
    { id: '1515', text: 'Quantitative Analyst' },
    { id: '1516', text: 'Regulatory Affairs' },
    { id: '1517', text: 'Risk Manager/Officer' },
    { id: '1518', text: 'Technology' },
    { id: '1519', text: 'Treasury' },
    { id: '1520', text: 'Other' }
];

const InformationProvider = [
    { id: '180', text: 'Business Development/Relationship Management' },
    { id: '181', text: 'Commodities Pricing' },
    { id: '182', text: 'Data Governance' },
    { id: '183', text: 'Engineer' },
    { id: '184', text: 'Executive Management' },
    { id: '185', text: 'Legal Affairs' },
    { id: '186', text: 'Market Data' },
    { id: '187', text: 'Operations' },
    { id: '188', text: 'Redistribution' },
    { id: '189', text: 'Reference Data' },
    { id: '1810', text: 'Regulatory Affairs' },
    { id: '1811', text: 'Sales/Marketing/PR' },
    { id: '1812', text: 'Technology' },
    { id: '1813', text: 'Other' }
];

const AutomobilesAndComponents = [
    { id: '40', text: 'Board Member/Trustee' },
    { id: '41', text: 'Business Development/Relationship Management' },
    { id: '42', text: 'Competitive Intelligence' },
    { id: '43', text: 'Corporate Development' },
    { id: '44', text: 'Credit Analyst' },
    { id: '45', text: 'Credit Manager/Officer' },
    { id: '46', text: 'Executive Management' },
    { id: '47', text: 'Finance/Planning' },
    { id: '48', text: 'Investor Relations' },
    { id: '49', text: 'Regulatory Affairs' },
    { id: '410', text: 'Risk Manager/Officer' },
    { id: '411', text: 'Supply Chain Management' },
    { id: '412', text: 'Treasury & Tax' },
    { id: '413', text: 'Other' }
];

const Transportation = [
    { id: '390', text: 'Board Member/Trustee' },
    { id: '391', text: 'Business Development/Relationship Management' },
    { id: '392', text: 'Competitive Intelligence' },
    { id: '393', text: 'Corporate Development' },
    { id: '3939', text: 'Credit Analyst' },
    { id: '395', text: 'Credit Manager/Officer' },
    { id: '396', text: 'Executive Management' },
    { id: '397', text: 'Finance/Planning' },
    { id: '398', text: 'Investor Relations' },
    { id: '399', text: 'Regulatory Affairs' },
    { id: '3910', text: 'Risk Manager/Officer' },
    { id: '3911', text: 'Supply Chain Management' },
    { id: '3912', text: 'Treasury & Tax' },
    { id: '3913', text: 'Other' }
];

const TradingComapaniesAndDistributors = [
    { id: '380', text: 'Board Member/Trustee' },
    { id: '381', text: 'Business Development/Relationship Management' },
    { id: '382', text: 'Competitive Intelligence' },
    { id: '383', text: 'Corporate Development' },
    { id: '3838', text: 'Credit Analyst' },
    { id: '385', text: 'Credit Manager/Officer' },
    { id: '386', text: 'Executive Management' },
    { id: '387', text: 'Finance/Planning' },
    { id: '388', text: 'Investor Relations' },
    { id: '389', text: 'Regulatory Affairs' },
    { id: '3810', text: 'Risk Manager/Officer' },
    { id: '3811', text: 'Supply Chain Management' },
    { id: '3812', text: 'Treasury & Tax' },
    { id: '3813', text: 'Other' }
];

const Technology = [
    { id: '360', text: 'Board Member/Trustee' },
    { id: '361', text: 'Business Development/Relationship Management' },
    { id: '362', text: 'Competitive Intelligence' },
    { id: '363', text: 'Corporate Development' },
    { id: '3636', text: 'Credit Analyst' },
    { id: '365', text: 'Credit Manager/Officer' },
    { id: '366', text: 'Executive Management' },
    { id: '367', text: 'Finance/Planning' },
    { id: '368', text: 'Investor Relations' },
    { id: '369', text: 'Regulatory Affairs' },
    { id: '3610', text: 'Risk Manager/Officer' },
    { id: '3611', text: 'Supply Chain Management' },
    { id: '3612', text: 'Treasury & Tax' },
    { id: '3613', text: 'Other' }
];

const Retailing = [
    { id: '340', text: 'Board Member/Trustee' },
    { id: '341', text: 'Business Development/Relationship Management' },
    { id: '342', text: 'Competitive Intelligence' },
    { id: '343', text: 'Corporate Development' },
    { id: '344', text: 'Credit Analyst' },
    { id: '345', text: 'Credit Manager/Officer' },
    { id: '346', text: 'Executive Management' },
    { id: '347', text: 'Finance/Planning' },
    { id: '348', text: 'Investor Relations' },
    { id: '349', text: 'Regulatory Affairs' },
    { id: '3410', text: 'Risk Manager/Officer' },
    { id: '3411', text: 'Supply Chain Management' },
    { id: '3412', text: 'Treasury & Tax' },
    { id: '3413', text: 'Other' }
];

const Metals = [
    { id: '240', text: 'Board Member/Trustee' },
    { id: '241', text: 'Business Development/Relationship Management' },
    { id: '242', text: 'Competitive Intelligence' },
    { id: '243', text: 'Corporate Development' },
    { id: '244', text: 'Credit Analyst' },
    { id: '245', text: 'Credit Manager/Officer' },
    { id: '246', text: 'Executive Management' },
    { id: '247', text: 'Finance/Planning' },
    { id: '248', text: 'Investor Relations' },
    { id: '249', text: 'Regulatory Affairs' },
    { id: '2410', text: 'Risk Manager/Officer' },
    { id: '2411', text: 'Supply Chain Management' },
    { id: '2412', text: 'Treasury & Tax' },
    { id: '2413', text: 'Other' }
];

const Materials = [
    { id: '220', text: 'Board Member/Trustee' },
    { id: '221', text: 'Business Development/Relationship Management' },
    { id: '222', text: 'Competitive Intelligence' },
    { id: '223', text: 'Corporate Development' },
    { id: '224', text: 'Credit Analyst' },
    { id: '225', text: 'Credit Manager/Officer' },
    { id: '226', text: 'Executive Management' },
    { id: '227', text: 'Finance/Planning' },
    { id: '228', text: 'Investor Relations' },
    { id: '229', text: 'Regulatory Affairs' },
    { id: '2210', text: 'Risk Manager/Officer' },
    { id: '2211', text: 'Supply Chain Management' },
    { id: '2212', text: 'Treasury & Tax' },
    { id: '2213', text: 'Other' }
];


const RealEstate = [
    { id: '310', text: 'Board Member/Trustee' },
    { id: '311', text: 'Business Development/Relationship Management' },
    { id: '312', text: 'Competitive Intelligence' },
    { id: '313', text: 'Corporate Development' },
    { id: '314', text: 'Credit Analyst' },
    { id: '315', text: 'Credit Manager/Officer' },
    { id: '316', text: 'Executive Management' },
    { id: '317', text: 'Finance/Planning' },
    { id: '318', text: 'Investor Relations' },
    { id: '319', text: 'Regulatory Affairs' },
    { id: '3110', text: 'Risk Manager/Officer' },
    { id: '3111', text: 'Supply Chain Management' },
    { id: '3112', text: 'Treasury & Tax' },
    { id: '3113', text: 'Other' }
];

const CapitalGoods = [
    { id: '50', text: 'Board Member/Trustee' },
    { id: '51', text: 'Business Development/Relationship Management' },
    { id: '52', text: 'Competitive Intelligence' },
    { id: '53', text: 'Corporate Development' },
    { id: '54', text: 'Credit Analyst' },
    { id: '55', text: 'Credit Manager/Officer' },
    { id: '56', text: 'Executive Management' },
    { id: '57', text: 'Finance/Planning' },
    { id: '58', text: 'Investor Relations' },
    { id: '59', text: 'Regulatory Affairs' },
    { id: '510', text: 'Risk Manager/Officer' },
    { id: '511', text: 'Supply Chain Management' },
    { id: '512', text: 'Treasury & Tax' },
    { id: '513', text: 'Other' }
];

const CommercialServicesAndSupplies = [
    { id: '70', text: 'Board Member/Trustee' },
    { id: '71', text: 'Business Development/Relationship Management' },
    { id: '72', text: 'Competitive Intelligence' },
    { id: '73', text: 'Corporate Development' },
    { id: '74', text: 'Credit Analyst' },
    { id: '75', text: 'Credit Manager/Officer' },
    { id: '76', text: 'Executive Management' },
    { id: '77', text: 'Finance/Planning' },
    { id: '78', text: 'Investor Relations' },
    { id: '79', text: 'Regulatory Affairs' },
    { id: '710', text: 'Risk Manager/Officer' },
    { id: '711', text: 'Supply Chain Management' },
    { id: '712', text: 'Treasury & Tax' },
    { id: '713', text: 'Other' }
];

const ConsumerServices = [
    { id: '90', text: 'Board Member/Trustee' },
    { id: '91', text: 'Business Development/Relationship Management' },
    { id: '92', text: 'Competitive Intelligence' },
    { id: '93', text: 'Corporate Development' },
    { id: '94', text: 'Credit Analyst' },
    { id: '95', text: 'Credit Manager/Officer' },
    { id: '96', text: 'Executive Management' },
    { id: '97', text: 'Finance/Planning' },
    { id: '98', text: 'Investor Relations' },
    { id: '99', text: 'Regulatory Affairs' },
    { id: '910', text: 'Risk Manager/Officer' },
    { id: '911', text: 'Supply Chain Management' },
    { id: '912', text: 'Treasury & Tax' },
    { id: '913', text: 'Other' }
];

const ConsumerDurablesAndApparel = [
    { id: '80', text: 'Board Member/Trustee' },
    { id: '81', text: 'Business Development/Relationship Management' },
    { id: '82', text: 'Competitive Intelligence' },
    { id: '83', text: 'Corporate Development' },
    { id: '84', text: 'Credit Analyst' },
    { id: '85', text: 'Credit Manager/Officer' },
    { id: '86', text: 'Executive Management' },
    { id: '87', text: 'Finance/Planning' },
    { id: '88', text: 'Investor Relations' },
    { id: '89', text: 'Regulatory Affairs' },
    { id: '810', text: 'Risk Manager/Officer' },
    { id: '811', text: 'Supply Chain Management' },
    { id: '812', text: 'Treasury & Tax' },
    { id: '813', text: 'Other' }
];

const FoodAndStaplesRetailing = [
    { id: '1110', text: 'Board Member/Trustee' },
    { id: '1111', text: 'Business Development/Relationship Management' },
    { id: '1112', text: 'Competitive Intelligence' },
    { id: '1113', text: 'Corporate Development' },
    { id: '1114', text: 'Credit Analyst' },
    { id: '1115', text: 'Credit Manager/Officer' },
    { id: '1116', text: 'Executive Management' },
    { id: '1117', text: 'Finance/Planning' },
    { id: '1118', text: 'Investor Relations' },
    { id: '1119', text: 'Regulatory Affairs' },
    { id: '11110', text: 'Risk Manager/Officer' },
    { id: '11111', text: 'Supply Chain Management' },
    { id: '11112', text: 'Treasury & Tax' },
    { id: '11113', text: 'Other' }
];

const FoodBeverageAndTobacco = [
    { id: '5550', text: 'Board Member/Trustee' },
    { id: '5551', text: 'Business Development/Relationship Management' },
    { id: '5552', text: 'Competitive Intelligence' },
    { id: '5553', text: 'Corporate Development' },
    { id: '5554', text: 'Credit Analyst' },
    { id: '5555', text: 'Credit Manager/Officer' },
    { id: '5556', text: 'Executive Management' },
    { id: '5557', text: 'Finance/Planning' },
    { id: '5558', text: 'Investor Relations' },
    { id: '5559', text: 'Regulatory Affairs' },
    { id: '55510', text: 'Risk Manager/Officer' },
    { id: '55511', text: 'Supply Chain Management' },
    { id: '55512', text: 'Treasury & Tax' },
    { id: '55513', text: 'Other' }
];

const HouseholdAndPersonalProducts = [
    { id: '160', text: 'Board Member/Trustee' },
    { id: '161', text: 'Business Development/Relationship Management' },
    { id: '162', text: 'Competitive Intelligence' },
    { id: '163', text: 'Corporate Development' },
    { id: '164', text: 'Credit Analyst' },
    { id: '165', text: 'Credit Manager/Officer' },
    { id: '166', text: 'Executive Management' },
    { id: '167', text: 'Finance/Planning' },
    { id: '168', text: 'Investor Relations' },
    { id: '169', text: 'Regulatory Affairs' },
    { id: '1610', text: 'Risk Manager/Officer' },
    { id: '1611', text: 'Supply Chain Management' },
    { id: '1612', text: 'Treasury & Tax' },
    { id: '1613', text: 'Other' }
];

const HealthcareEquipmentAndServices = [
    { id: '140', text: 'Board Member/Trustee' },
    { id: '141', text: 'Business Development/Relationship Management' },
    { id: '142', text: 'Competitive Intelligence' },
    { id: '143', text: 'Corporate Development' },
    { id: '144', text: 'Credit Analyst' },
    { id: '145', text: 'Credit Manager/Officer' },
    { id: '146', text: 'Executive Management' },
    { id: '147', text: 'Finance/Planning' },
    { id: '148', text: 'Healthcare Professional' },
    { id: '149', text: 'Investor Relations' },
    { id: '1410', text: 'Regulatory Affairs' },
    { id: '1411', text: 'Risk Manager/Officer' },
    { id: '1412', text: 'Supply Chain Management' },
    { id: '1413', text: 'Treasury & Tax' },
    { id: '1414', text: 'Other' }
];

const PharmaceuticalsBiotechnologyAndLifeSciences = [
    { id: '270', text: 'Board Member/Trustee' },
    { id: '271', text: 'Business Development/Relationship Management' },
    { id: '272', text: 'Competitive Intelligence' },
    { id: '273', text: 'Corporate Development' },
    { id: '274', text: 'Credit Analyst' },
    { id: '275', text: 'Credit Manager/Officer' },
    { id: '276', text: 'Executive Management' },
    { id: '277', text: 'Finance/Planning' },
    { id: '278', text: 'Healthcare Professional' },
    { id: '279', text: 'Investor Relations' },
    { id: '2710', text: 'Regulatory Affairs' },
    { id: '2711', text: 'Risk Manager/Officer' },
    { id: '2712', text: 'Supply Chain Management' },
    { id: '2713', text: 'Treasury & Tax' },
    { id: '2714', text: 'Other' }
];

const Media = [
    { id: '230', text: 'Board Member/Trustee' },
    { id: '231', text: 'Business Development/Relationship Management' },
    { id: '232', text: 'Competitive Intelligence' },
    { id: '233', text: 'Corporate Development' },
    { id: '234', text: 'Credit Analyst' },
    { id: '235', text: 'Credit Manager/Officer' },
    { id: '236', text: 'Executive Management' },
    { id: '237', text: 'Finance/Planning' },
    { id: '238', text: 'Investor Relations' },
    { id: '239', text: 'Regulatory Affairs' },
    { id: '2310', text: 'Reporter/Journalist/Editor' },
    { id: '2311', text: 'Risk Manager/Officer' },
    { id: '2312', text: 'Sales/Marketing/PR' },
    { id: '2313', text: 'Supply Chain Management' },
    { id: '2314', text: 'Treasury & Tax' },
    { id: '2315', text: 'Other' }
];

const OilGas = [
    { id: '250', text: 'Board Member/Trustee' },
    { id: '251', text: 'Business Development/Relationship Management' },
    { id: '252', text: 'Competitive Intelligence' },
    { id: '253', text: 'Corporate Development' },
    { id: '254', text: 'Credit Analyst' },
    { id: '255', text: 'Credit Manager/Officer' },
    { id: '256', text: 'Executive Management' },
    { id: '257', text: 'Finance/Planning' },
    { id: '258', text: 'Fuels Admin' },
    { id: '259', text: 'Investor Relations' },
    { id: '2510', text: 'Regulatory Affairs' },
    { id: '2511', text: 'Risk Manager/Officer' },
    { id: '2512', text: 'Supply Chain Management' },
    { id: '2513', text: 'Treasury & Tax' },
    { id: '2514', text: 'Other' }
];

const AuditorsAccounting = [
    { id: '30', text: 'Audit/Accounting' },
    { id: '31', text: 'Business Development/Relationship Management' },
    { id: '32', text: 'Management Consulting' },
    { id: '33', text: 'Risk Manager/Officer' },
    { id: '34', text: 'Treasury & Tax' },
    { id: '35', text: 'Other' }
];

const LawFirm = [
    { id: '530', text: 'Attorney/Partner' },
    { id: '531', text: 'Business Development/Relationship Management' },
    { id: '532', text: 'Conflict Resolution' },
    { id: '533', text: 'Librarian' },
    { id: '534', text: 'Regulatory Affairs' },
    { id: '535', text: 'Treasury & Tax' },
    { id: '536', text: 'Other' }
];

const PublicRelationsInvestorRelations = [
    { id: '3000', text: 'Business Development/Relationship Management' },
    { id: '3001', text: 'Investor Relations' },
    { id: '3002', text: 'Other' }
];

const RecruiterHeadhunter = [
    { id: '330', text: 'Business Development/Relationship Management' },
    { id: '331', text: 'HR Professional' },
    { id: '332', text: 'Recruiting' },
    { id: '333', text: 'Other' }
];

const StrategyBusinessConsulting = [
    { id: '350', text: 'Advisory' },
    { id: '351', text: 'Business Development/Relationship Management' },
    { id: '352', text: 'Management Consulting' },
    { id: '353', text: 'Risk Manager/Officer' },
    { id: '354', text: 'Other' }
];

const TradeAssociation = [
    { id: '370', text: 'Business Development/Relationship Management' },
    { id: '371', text: 'Other' }
];

const Academia = [
    { id: '0', text: 'Faculty' },
    { id: '1', text: 'Librarian' },
    { id: '2', text: 'PhD Student' },
    { id: '3', text: 'Undergrad and MBA Student' },
    { id: '4', text: 'Other' }
];

const GovernmentEntityRegulatory = [
    { id: '130', text: 'Government Official' },
    { id: '131', text: 'Regulatory Affairs' },
    { id: '132', text: 'Treasury & Tax' },
    { id: '133', text: 'Other' }
];

const Individual = [
    { id: '170', text: 'Individual Investor' },
    { id: '171', text: 'PhD Student' },
    { id: '172', text: 'Undergrad and MBA Student' },
    { id: '173', text: 'Other' }
];

const Other = [
    { id: '40', text: 'Individual Investor' },
    { id: '41', text: 'PhD Student' },
    { id: '42', text: 'Undergrad and MBA Student' },
    { id: '43', text: 'Other' }
];

export {
    countryList,
    optInList,
    usStates,
    ausProv,
    canProv,
    chinaProv,
    companyTypeList,
    InvestmentBank,
    PrivateEquity,
    CommercialBank,
    CreditUnion,
    Insurance,
    AssetManager,
    InformationProvider,
    AutomobilesAndComponents,
    HealthcareEquipmentAndServices,
    Media,
    OilGas,
    AuditorsAccounting,
    LawFirm,
    PublicRelationsInvestorRelations,
    RecruiterHeadhunter,
    StrategyBusinessConsulting,
    TradeAssociation,
    Academia,
    GovernmentEntityRegulatory,
    Individual,
    AssetOwner,
    HedgeFund,
    CapitalGoods,
    CommercialServicesAndSupplies,
    ConsumerDurablesAndApparel,
    ConsumerServices,
    FoodAndStaplesRetailing,
    FoodBeverageAndTobacco,
    HouseholdAndPersonalProducts,
    Other,
    PharmaceuticalsBiotechnologyAndLifeSciences,
    RealEstate,
    Metals,
    Materials,
    Retailing,
    Technology,
    TradingComapaniesAndDistributors,
    Transportation
};
